import { useState } from "react";
import { requestGetQuantityEvents } from "services/events/aboutEvents";
import { RECORDS_BY_PAGE } from "../constants";

const useTitleTabViews = ({
    dataPaginator, setDataPaginator, 
    filters, tabData, currentTab
}) => {
	const [titleTabViews, setTitleTabViews] = useState(null);
    const fillTitleViews = async () => {
		const { currentPage } = dataPaginator;
		const quantityEvents = await requestGetQuantityEvents({
			...filters.value,
		});
		setTitleTabViews({ ...quantityEvents });
		const quantityEventsByTab = quantityEvents[tabData.fields[currentTab.index]];
		setDataPaginator({
			currentPage,
			quantityPages: Math.ceil(quantityEventsByTab / RECORDS_BY_PAGE),
		});
	}
    return {
        value: titleTabViews,
        fill: fillTitleViews
    };
}	
    
export default useTitleTabViews;